// Size.jsx
import { Suspense, lazy, useEffect, useState } from "react";
import {
 PlusButton,
 ActionButton,
 ToggleSwitch,
 checkImage,
} from "../../helper/ImageFormat";
import Breadcrumb from "../../helper/Breadcrumb";
import Spinner from "../../Components/spinner";
import { toggleStatus, deleteItem } from "../../utils/apiUtils";
import { fetchAllData } from "../../helper/ProductAttributeHandling";
import { useNavigate } from "react-router-dom";
const DeleteModal = lazy(() => import("../../Components/DeleteModel"));

const Popups = () => {
 const navigate = useNavigate();
 const [loading, setLoading] = useState(false);
 const [popupsData, setpopupsData] = useState([]);
 const [deleteItemId, setDeleteItemId] = useState({});
 const [deleteModalOpen, setDeleteModalOpen] = useState(false);
 const [isDeleting, setIsDeleting] = useState(false);

 const fetchData = async () => {
  await fetchAllData("popups", setpopupsData, null, setLoading);
 };

 useEffect(() => {
  fetchData();
 }, []);

 const handleEditClick = (data) => {
  navigate("/add-popups", { state: data });
 };

 const handleDelete = async (data) => {
  setDeleteItemId(data);
  setDeleteModalOpen(true);
 };

 const confirmDelete = async () => {
  setIsDeleting(true);
  try {
   const res = await deleteItem("popups", deleteItemId?.id, fetchData, [
    deleteItemId?.image,
   ]);
   setDeleteItemId({});
   setDeleteModalOpen(false);
   return res;
  } catch (error) {
   return error;
  } finally {
   setIsDeleting(false);
  }
 };

 const handleStatusToggle = async (item) => {
  const updated = await toggleStatus("popus-status", item.id, item.isActive);
  if (updated) {
   setpopupsData((prev) =>
    prev.map((s) =>
     s.id === item.id ? { ...s, isActive: updated.isActive } : s
    )
   );
  }
 };

 const handleAdd = () => {
  navigate("/add-popups");
 };
 const breadcrumbData = [
  { label: "Home", path: "/" },
  { label: "Popups", path: "/popups" },
 ];

 return (
  <div className="content-wrapper">
   <div className="page-header mt-5">
    <h3 className="custom-page-title">Popups</h3>
    <Breadcrumb items={breadcrumbData} />
   </div>
   <div
    className="d-flex justify-content-end bg-white p-2 mt-n2"
    style={{ gap: "10px" }}
   >
    <PlusButton handleAdd={handleAdd} module={"Sizes"} />
   </div>

   <div className="row mt-2">
    <div className="col-md-12 grid-margin stretch-card">
     <div className="card">
      <div className="card-body ">
       <div className="table-responsive">
        <table id="popups" className="custom-table table table-striped">
         <thead>
          <tr style={{ marginTop: "10px", border: "2px solid #fff" }}>
           <th>Image</th>
           <th>Type</th>
           <th>Heading</th>
           <th>Modal Position</th>
           <th>Delay</th>
           <th>Autoclose</th>
           <th>Active</th>
           <th style={{ width: "120px" }}>Action</th>
          </tr>
         </thead>
         <tbody>
          {loading ? (
           <tr>
            <td colSpan="12" className="text-center">
             <Spinner />
            </td>
           </tr>
          ) : popupsData.length > 0 ? (
           popupsData.map((item, index) => (
            <tr key={item.id || index}>
             <td>
                {checkImage(item?.image)}
             </td>
             <td>{item?.type}</td>
             <td>{item?.heading}</td>
             <td>{item?.modalPosition}</td>
             <td>{item?.delay}s</td>
             <td>{item?.autoclose}</td>
             <td>
              <ToggleSwitch
               data={item}
               name="isActive"
               checked={item.isActive}
               handleStatusToggle={handleStatusToggle}
               module={"Sizes"}
              />
             </td>
             <td>
              <ActionButton
               data={item}
               module={"Popups"}
               handleEditClick={handleEditClick}
               handleDelete={handleDelete}
              />
             </td>
            </tr>
           ))
          ) : (
           <tr>
            <td colSpan="12" className="text-center">
             <h5>No data found.</h5>
            </td>
           </tr>
          )}
         </tbody>
        </table>
       </div>
      </div>
     </div>
    </div>
   </div>

   <Suspense fallback={null}>
    {deleteModalOpen && (
     <DeleteModal
      deleteModalOpen={deleteModalOpen}
      setDeleteModalOpen={() => setDeleteModalOpen(false)}
      onConfirm={confirmDelete}
      itemName="Popups"
      isDeleting={isDeleting}
     />
    )}
   </Suspense>
  </div>
 );
};

export default Popups;
